import { Check } from "lucide-react";
import SectionHeader from "../SectionHeader";
import Reveal from "../Reveal";
import { COMPARISON } from "../../data/site";

const VDYO_COL = COMPARISON.cols.length - 1;

const DesktopTable = () => (
  <table data-testid="comparison-table" className="hidden md:table w-full border-collapse text-left">
    <thead>
      <tr className="border-b border-white/10">
        <th className="py-4 pr-6 w-[22%]" />
        {COMPARISON.cols.map((c, i) => (
          <th
            key={c}
            data-testid={`comparison-col-${i}`}
            className={`py-4 px-5 font-heading text-sm font-extrabold uppercase tracking-[0.18em] ${
              i === VDYO_COL ? "text-[#C8F031] bg-[#C8F031]/[0.06] rounded-t-2xl" : "text-white/50"
            }`}
          >
            {c}
          </th>
        ))}
      </tr>
    </thead>
    <tbody>
      {COMPARISON.rows.map(([label, ...cells], r) => (
        <tr key={label} data-testid={`comparison-row-${r}`} className="border-b border-white/10 last:border-0">
          <th scope="row" className="py-5 pr-6 font-heading text-sm font-bold text-white align-top">
            {label}
          </th>
          {cells.map((cell, i) => (
            <td
              key={i}
              className={`py-5 px-5 text-sm leading-relaxed align-top ${
                i === VDYO_COL
                  ? "text-white font-medium bg-[#C8F031]/[0.06] " + (r === COMPARISON.rows.length - 1 ? "rounded-b-2xl" : "")
                  : "text-white/50"
              }`}
            >
              {cell}
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  </table>
);

const MobileCards = () => (
  <div className="md:hidden space-y-3" data-testid="comparison-cards">
    {COMPARISON.rows.map(([label, ...cells], r) => (
      <div key={label} data-testid={`comparison-card-${r}`} className="rounded-2xl border border-white/10 bg-white/[0.03] p-5">
        <p className="font-heading text-sm font-bold text-white">{label}</p>
        <dl className="mt-3 space-y-2">
          {cells.map((cell, i) => (
            <div key={i} className="flex items-baseline justify-between gap-4">
              <dt className={`shrink-0 text-[11px] font-heading font-bold uppercase tracking-[0.18em] ${i === VDYO_COL ? "text-[#C8F031]" : "text-white/35"}`}>
                {COMPARISON.cols[i]}
              </dt>
              <dd className={`text-right text-sm leading-snug ${i === VDYO_COL ? "text-white font-medium" : "text-white/50"}`}>
                {i === VDYO_COL && <Check className="inline w-3.5 h-3.5 text-[#C8F031] mr-1.5 -mt-0.5" strokeWidth={3} />}
                {cell}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    ))}
  </div>
);

export const WhyUs = () => (
  <section data-testid="why-us-section" className="bg-black section-pad">
    <div className="container-x">
      <SectionHeader
        align="split"
        eyebrow="Why us"
        eyebrowTestId="why-us-eyebrow"
        title="Three ways to get your videos edited."
        support="If you can keep a great in-house editor busy, hire one. Most people can't yet, and that's where we fit."
      />
      <Reveal>
        <DesktopTable />
        <MobileCards />
      </Reveal>
    </div>
  </section>
);

export default WhyUs;
